import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { CallApi, CommonModal } from '../../../Components/common/CommonFunctions'
import { toast } from 'react-toastify';
import { ReactComponent as EditIcon } from "../../../assets/images/settings_icon/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/settings_icon/delete.svg";
import { useShiftAssetQuery } from '../../../redux/services/SPL'
import { ReactComponent as SaveIcon } from "../../../assets/images/save.svg";

import TableGrid from "../../../Components/common/TableGrid";

const Assets = () => {

    const isMounted = useRef(false);
    const [addModal, setAddModal] = useState(false)

    const [position, setPosition] = useState('')
    const [formData, setFormData] = useState({})

    const { data: myData, isFetching, refetch } = useShiftAssetQuery({
        // skip: pageDetails.pagesize === 0,
        // refetchOnMountOrArgChange: true,
    });

    const columns = [
        {
            label: "", field: "actions", enableSearch: false, cls: 'single_action', cls: 'tw-1',
            renderCell: (row) => (<div className="tb_grid_actions">
                <EditIcon className="row_view" style={{ cursor: "pointer" }}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleAdd('E', row)
                    }} />
                <DeleteIcon className="row_msg" style={{ cursor: "pointer", marginLeft: "6px" }}
                    onClick={(e) => {
                        e.stopPropagation();

                    }} />
            </div>),
        },
        { label: "Asset Name", field: "title", enableSearch: false, cls: 'tw-10' },

    ];

    const handleAdd = (pos, dta) => {
        console.log('dta', dta);

        if (pos === 'E') {
            setFormData(dta)
        } else {
            setFormData({})
        }
        setPosition(pos)
        setAddModal(true)
    }
    const modalClose = () => {
        setAddModal(false)
    }
    const HandleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleSave = () => {
        CallApi({
            endPoint: 'shift-report/save-asset',
            payload: formData,
            onSuccess: (res) => {

                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg)
                    refetch()
                    setFormData({})
                    setAddModal(false);
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    return (
        <>
            <div className='d-flex justify-content-between align-items-center'>
                <div>
                    <h4>Assets</h4>
                    <p>Manage and customize department configurations</p>
                </div>
                <div>
                    <Button variant="primary" className='create_btn' onClick={handleAdd}>
                        <FontAwesomeIcon icon={faPlus} /> Add Asset
                    </Button>
                </div>

            </div>
            <hr />
            <div className='tw-50 setting_table'>
                <TableGrid
                    columns={columns}
                    rows={myData?.response_data}
                    checkboxSelection={false}
                    totalRecords={myData?.TotalRows || 0}
                    onClickRow={(row) => {
                        console.log("Clicked Row:", row);
                    }}
                    loading={isFetching}
                    // bulkActions={bulkActions}
                    rowKey="id"
                />
            </div>
            {/* <div className="table-container">
                <table>
                    <tr>
                        <th>Assets Name</th>
                    </tr>
                    {assets.map((asset, index) => (
                        <tr key={asset.id + index}>
                            <td><EditIcon className="row_view" style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleAdd('E', asset)
                                }} />
                                <DeleteIcon className="row_msg" style={{ cursor: "pointer", marginLeft: "6px" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (asset) {

                                        }
                                    }} />
                            </td>
                            <td>{asset.title}</td>
                        </tr>
                    ))}
                </table>
            </div> */}
            {addModal &&
                <CommonModal
                    show={addModal}
                    onHide={modalClose}
                    title={`${position === 'E' ? 'Edit' : 'Add'} Asset`}
                    subTitle={`${position === 'E' ? 'Edit' : 'Create Asset a new'} department configuration`}
                    className='addfrom modal_bgw primary_modal'
                    footer={
                        <div className='d-flex justify-content-between'>
                            <div></div>
                            <Button variant="primary" className='defult_save' onClick={handleSave}>
                                <SaveIcon /> 
                                {position === 'E' ? 'Update' : 'Save'}
                            </Button>
                        </div>
                    }>

                    <Form.Group>
                        <Form.Label>Asset Name</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder="Asset Name"
                            name="title"
                            value={formData.title}
                            onChange={HandleChange}
                        />
                    </Form.Group>
                </CommonModal>
            }
        </>
    )
}

export default Assets